import createAxiosConfig from "../config/createAxiosConfig";
import store from "../config/store";

class SiafLiteImpressoraApi {
  constructor(url) {
    this.url = url;
    this.axiosConfig = createAxiosConfig(store.urlImpressora);
  }

  async post(body) {
    return this.axiosConfig
      .post(this.url, body)
      .then(function (reponse) {
        return reponse;
      })
      .catch(function (erro) {
        return erro;
      });
  }

  async get(filter) {
    let urlGet = this.url;
    if (filter) {
      urlGet = gerarUrlComFiltro(this.url, filter);
    }
    return this.axiosConfig
      .get(urlGet)
      .then(function (reponse) {
        return reponse;
      })
      .catch(function (erro) {
        return erro;
      });
  }
}

function gerarUrlComFiltro(url, filter) {
  let filtroString = "";
  for (const key in filter) {
    if (filter[key]) {
      const parametroFilro = filter[key]?.toString().replaceAll(/\s/g, "+");
      if (filtroString) {
        filtroString += `&${key}=${parametroFilro}`;
      } else {
        filtroString += `${key}=${parametroFilro}`;
      }
    }
  }
  return `${url}?${filtroString}`;
}

export default SiafLiteImpressoraApi;
